//
//  useGhaCsvSummarySelector.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useState, useEffect } from "react";
import { ghaCsvSummaryItems } from "../constants/ghaCsv";
import { localStorageManager } from "../utils/localStorage";

const LOCAL_STORAGE_KEY = localStorageManager.SELECTED_GHA_CSV_SUMMARY_ITEMS;

const useGhaCsvSummarySelector = () => {
  const allItems = ghaCsvSummaryItems.map((item) => item.type);

  // lazy initializerで同期的に復元し、マウント時のeffect順序による
  // localStorage上書き・表示ちらつきを避ける
  const [selectedGhaCsvSummaryItems, setSelectedGhaCsvSummaryItems] = useState<
    string[]
  >(() => {
    try {
      const stored = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || "[]"
      );
      if (!Array.isArray(stored)) return allItems;
      // 項目定義の変更で存在しなくなったタイプを除外する
      const valid = stored.filter((item) => allItems.includes(item));
      return valid.length ? valid : allItems;
    } catch {
      return allItems;
    }
  });

  useEffect(() => {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify(selectedGhaCsvSummaryItems)
    );
  }, [selectedGhaCsvSummaryItems]);

  const errorMsg =
    selectedGhaCsvSummaryItems.length === 0
      ? "1つ以上のサマリー項目を選択してください。"
      : "";

  return {
    selectedGhaCsvSummaryItems,
    setSelectedGhaCsvSummaryItems,
    errorMsg,
  };
};

export default useGhaCsvSummarySelector;
